import { Component } from 'preact';

export default class Commentary extends Component {
  state = {
    visible: true
  }

  updateVisibility ({ items = [] }) {
    const visible = items.length > 0;

    if (visible !== this.state.visible) {
      this.setState({ visible });
    }
  }

  componentWillMount () {
    this.updateVisibility(this.props);
  }

  componentWillReceiveProps (props) {
    this.updateVisibility(props);
  }

  render ({ items = [] }, { visible }) {
    return <section id="commentary" class={`Commentary${visible ? ' visible' : ''}`}>
      <div class="container">
      {
        items.length > 0 && items.map(
          ({ title='', summary='', url = false, region, city, village }) => {
            const location = [region, city, village]
            .filter(place => !!place)
            .join(', ');

            return <article>
              <header>
                { location &&
                  <h3><a href={url} target="_blank">{ location }</a></h3>
                }
                <h4><a href={url} target="_blank">{ title }</a></h4>
              </header>

              {
                summary
                .split('\n')
                .map(line => <p>{ line }</p>)
              }
            </article>;
          })
      }
      </div>

      {
        items.length > 0 && <footer>
          <p class="socialmedia">Follow us on <a href="https://twitter.com/angliaruskin" target="_blank"><span class="icon-twitter"/></a> <a href="https://www.facebook.com/angliaruskin" target="_blank"><span class="icon-facebook"/></a></p>
        </footer>
      }
    </section>;
  }
}



// WEBPACK FOOTER //
// ./components/Commentary.js